import styled, { css } from 'styled-components'
import media from 'styled-media-query'

const wrapperModifiers = {
  show: () => css`
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.25);

    div {
      opacity: 1;
    }
  `,
}

export const Wrapper = styled.div`
  position: relative;
  min-height: 370px;
  width: 250px;
  flex: 1 0 345px;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.25);

  img {
    width: 100%;
    height: 100%;
    max-height: 290px;
    object-fit: cover;
    object-position: top;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.25);

      div {
        opacity: 1;
      }
    }
  }

  ${media.lessThan('medium')`
    box-shadow: 4px 8px 14px rgba(0, 0, 0, 0.25);
  `}

  @keyframes placeholderShimmer {
    0% {
      background-position: -40rem 0;
    }

    100% {
      background-position: 40rem 0;
    }
  }

  ${({ show }) => show && wrapperModifiers.show()};
`

export const Content = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  top: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Top = styled.div`
  width: 100%;
  height: 230px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

export const Bottom = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 140px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    background-color: white;

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 70px;
      height: 5px;
      background-color: #ECB11F;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
  `}
`

export const VerMais = styled.button`
  ${({ theme }) => css`
    color: ${theme.colors.primary.main};
    font-size: 16px;
    height: 40px;
    font-weight: 400;
    cursor: pointer;
    position: relative;
    bottom: 10px;
    display: none;

    &::after {
      background-color: ${theme.colors.primary.main};
      border-radius: 2px;
      content: '';
      position: absolute;
      width: 0;
      height: 2px;
      left: 50%;
      bottom: 6px;
      transform: translateX(-50%);
      opacity: 0;
      transition: width 0.25s ease, opacity 500ms ease;
    }

    &:hover {
      &::after {
        width: 100%;
        opacity: 1;
      }
    }
  `}
`

export const Title = styled.h5`
  ${({ theme }) => css`
    background-color: ${theme.colors.secondary};
    color: ${theme.colors.white};
    font-size: ${theme.font.sizes.medium};
    font-family: ${theme.font.family};
    line-height: 1.4;
    font-weight: 400;
    min-height: 100px;
    padding: ${theme.spacings.xsmall};
    text-align: center;
  `}
`